import React, { Component } from 'react';

import Breadcrumb from './../Breadcrumb/Breadcrumb';
import LeftNavigation from './../LeftNavigation/LeftNavigation';
import Alert from './../Alert/Alert'
import { isMobile } from "react-device-detect";
import ThdCreditCard from 'thd-credit-card';
import AccountSnapshot from 'account-snapshot';
import '../SaveThdCreditCard/SaveThdCreditCard.css';

export default class ThdCreditCardWrapper extends Component {
  constructor(props) {
    super(props);
    this.myAccountListItems = {
      links: {
        'Profile': {
          url: '/account/view/profile',
          dataAutomationId:'MyAccountProfileLink',
          active: false
        },
        'Security': {
          url: '/account/ui/security',
          dataAutomationId:'MyAccountSecurityLink',
          active: false
        },
        'Address Book': {
          url: '/account/view/addresses',
          dataAutomationId:'MyAccountAddressBookLink',
          active: false
        },
        'My Payment Methods': {
          url: '/account/view/paymentcards',
          dataAutomationId:'MyAccountSavedCreditCardsLink',
          active: false
        },
        'My Home Depot Credit Card': {
          url: '/account/view/thdcreditcard',
          dataAutomationId:'',
          active: true
        },
        'Instant Checkout Settings': {
          url: '/account/view/oneclick-settings',
          dataAutomationId:'MyAccountInstantCheckoutSettingsLink',
          active: false
        },
        'Instant Checkout Settings': {
          url: '/account/view/instantcheckout',
          active: false
        },
        'Email Preferences': {
          url: '/account/view/emailsubscription',
          dataAutomationId:'MyAccountEmailPreferancesLink',
          active: false
        },
        'My Ratings & Reviews': {
          url: '/order/view/myratingsandreviews',
          dataAutomationId:'MyAccountMyRatingsAndReviewLink',
          active: false
        },
        'My Window Treatments': {
          url: 'https://install.homedepot.com/schedule',
          dataAutomationId:'MyAccountMyWindowTreatmentsLink',
          active: false
        }
      }
    };

    // hide Security link if switch is OFF
    try {
      if (window.THD_ACCOUNT_GLOBAL &&
          window.THD_ACCOUNT_GLOBAL.featureSwitches &&
          ((window.THD_ACCOUNT_GLOBAL.featureSwitches.ENABLE_SECURITY_APP === 0) || (window.THD_ACCOUNT_GLOBAL.featureSwitches.ENABLE_SECURITY_APP === null))) {
        delete this.myAccountListItems.links['Security'];
      }
    } catch( e ) { console.log('Error deleting Security link from left nav in THDCreditCard ',e)}

    this.state = {
      version: '1.4.47',
      app_error: false,
      app_error_text: '',
      app_success: false,
      app_success_text: '',
      profile: {},
      navigation: {
        'Orders and Purchases': {
          links: {
            'Online Orders': {
              url: '/order/view/summary',
              dataAutomationId:'MyAccountOrderAndPurchasesOnlineOrders',
              active: false
            },
            'Subscriptions': {
              url: '/account/view/ordersubscription',
              dataAutomationId:'MyAccountOrderAndPurchasesSubscription',
              active: false
            },
            'In Store e-Receipts': {
              url: '/order/view/ereceipt/summary',
              dataAutomationId:'MyAccountOrderAndPurchasesInStoreEReceipts',
              active: false
            },
            'In Store Orders': {
              url: '/order/view/instoresummary',
              dataAutomationId:'MyAccountOrderAndPurchasesInStoreOrders',
              active: false
            },
            'Installation Orders': {
              url: 'https://hdapps.homedepot.com/MyInstall/Customer/MyInstallOrderSummary.jsp?forwardPage=OrderSummary&Sourceflag=1',
              dataAutomationId:'MyAccountOrderAndPurchasesInstallationOrders',
              active: false
            },
          }
        },
        'For The Pros': {
          links: {
            'The Place for Pros': {
              url: '/c/professional_contractor',
              dataAutomationId:'',
              active: false
            },
            'Pro Xtra Loyalty Program':{
              url: '/CustRecogPortal/#/authentication',
              dataAutomationId:'',
              active: false
            }
          }
        },
        'Account Information': this.myAccountListItems,
        'Lists': {
          links: {
            'My Lists': {
              url: '/list/view/summary',
              dataAutomationId:'MyAccountListsMyLists',
              active: false
            },
            'Find a List': {
              url: '/list/view/search',
              dataAutomationId:'MyAccountListsFindList',
              active: false
            },
          }
        },
        'Credit and Gift Cards': {
          links: {
            'Pay Credit Card': {
              url: 'https://www.homedepot.com/c/Credit_Center',
              dataAutomationId:'MyAccountCreditAndGiftCardPayCreditCard',
              active: false
            },
            'Gift Card Balance': {
              url: '/mycheckout/giftcard',
              dataAutomationId:'MyAccountCreditAndGiftCardGiftCardBalance',
              active: false
            },
            'Credit Center': {
              url: 'https://www.homedepot.com/c/Credit_Center',
              dataAutomationId:'MyAccountCreditAndGiftCardCreditCenter',
              active: false
            },
            'My Home Depot Credit Card': {
              url: '/account/view/thdcreditcard',
              dataAutomationId:'',
              active: true
            },
          }
        }
      }
    }
    this.setAppError = this.setAppError.bind(this);
    this.resetAppError = this.resetAppError.bind(this);
    this.setAppSuccess = this.setAppSuccess.bind(this);
    this.resetAppSuccess = this.resetAppSuccess.bind(this);
    this.resetAppAlert = this.resetAppAlert.bind(this);
  }

  render() {
    const profile = {profile:{loyaltyEnrollmentIndicator : false}};
    let isAccountSnapshotEnabled = false;
    let isCommericalSsoEnabled = false;
    let isCovidBannerEnabled = false;
    if (window.THD_ACCOUNT_GLOBAL && window.THD_ACCOUNT_GLOBAL.featureSwitches) {
      isAccountSnapshotEnabled = (window.THD_ACCOUNT_GLOBAL.featureSwitches.CITI_ACCOUNT_SNAPSHOT_ENABLED === 1 || document.cookie.indexOf('testAccountSnapshot')!== -1);
      isCommericalSsoEnabled = (window.THD_ACCOUNT_GLOBAL.featureSwitches.CITI_COMMERCIAL_SSO_ENABLED === 1 || document.cookie.indexOf('testCommercialSso') !== -1);
      isCovidBannerEnabled = (window.THD_ACCOUNT_GLOBAL.featureSwitches.CITI_COVID_BANNER_ENABLED === 1 || document.cookie.indexOf('testCitiCovidBanner') !== -1);
    }
    return (

      <div className='flex-column grid isBound'>
        {root.dataset.nativeapp === 'true' ? null :
          <div className='col__12-12'>
              <Breadcrumb currentPage='My Home Depot Credit Card'/>
          </div>
        }

        {this.state.app_error ?
          <Alert
            resetAppAlert={this.resetAppAlert}
            bold={this.state.app_error_bold}
            type={'danger'}
            text={this.state.app_error_text}
            fill={false}>
          </Alert>
          :
          null}
        {this.state.app_success ?
          <Alert
            resetAppAlert={this.resetAppAlert}
            bold={this.state.app_success_bold}
            type={'success'}
            text={this.state.app_success_text}
            fill={false}>
          </Alert>
          :
          null}

        <main className='flex-row'>
          {isMobile ? null
            :
            <div className='left-navigation'>
              <LeftNavigation profile={profile} navigation={this.state.navigation}></LeftNavigation>
            </div>}

          <div className={isMobile ? 'flex-1 col__12-12' : 'flex-1'}>
            {isAccountSnapshotEnabled ? <AccountSnapshot isCommercialEnabled = {isCommericalSsoEnabled} isCovidBannerEnabled = {isCovidBannerEnabled}></AccountSnapshot>
            : <ThdCreditCard></ThdCreditCard> }
          </div>
        </main>
      </div>
    );
  }
  setAppError(bold, text) {
    this.setState({
      app_error: true,
      app_success: false,
      app_error_text: text,
      app_error_bold: bold,
    })
  }
  resetAppError() {
    this.setState({
      app_error: false,
      app_error_text: '',
      app_error_bold: '',
    })
  }
  setAppSuccess(bold, text) {
    this.setState({
      app_success: true,
      app_error: false,
      app_success_text: text,
      app_success_bold: bold,
    })
  }
  resetAppSuccess() {
    this.setState({
      app_success: false,
      app_success_text: '',
    })
  }
  resetAppAlert() {
    this.setState({
      app_success: false,
      app_error: false,
      app_success_text: '',
      app_success_bold: '',
    })
  }
}



// WEBPACK FOOTER //
// ./src/Components/ThdCreditCard/ThdCreditCard.js